import { ROLE } from '@cmoh/shared'
import type { AppRoute } from '@/lib/routing/routing.types'
import { lazyWithRetry } from '@/lib/utils/lazy-with-retry'

const GeoAuditPage = lazyWithRetry(() => import('./pages/GeoAuditPage'))

const routes: AppRoute[] = [
  {
    path: 'geo-audit',
    element: GeoAuditPage,
    meta: {
      title: 'Auditor GEO',
      require: { minRole: ROLE.MEMBER },
    },
  },
]

export default routes
